import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import grandParkLivingData from '../../data/projects/grandparkliving.js';

function GrandParkLiving() {
  return <ProjectPage projectData={grandParkLivingData} />;
}

export default GrandParkLiving;
